import axios from 'axios';

// Configurar interceptor global para manejar expiración de tokens
axios.interceptors.response.use(
  // Si la respuesta es exitosa, simplemente la retornamos
  (response) => response,
  
  // Si hay un error, lo manejamos aquí
  (error) => {
    // Verificar si es un error de autenticación (401) o autorización (403)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('[Auth] Token expirado o inválido. Cerrando sesión...');
      
      // Determinar si es un usuario admin o cliente basado en la URL o token
      const currentPath = window.location.pathname;
      const isAdminRoute = currentPath.startsWith('/admin') || 
                           currentPath.startsWith('/home') || 
                           currentPath.startsWith('/karaoke') ||
                           currentPath.startsWith('/videos') ||
                           currentPath.startsWith('/subscription') ||
                           currentPath.startsWith('/billing') ||
                           currentPath.startsWith('/purchase') ||
                           currentPath.startsWith('/branding') ||
                           currentPath.startsWith('/payment');
      
      const isClientRoute = currentPath.startsWith('/client');
      
      // Limpiar tokens según el tipo de usuario
      if (isAdminRoute) {
        console.log('[Auth] Limpiando sesión de administrador');
        localStorage.removeItem('token');
        
        // Mostrar mensaje antes de redirigir
        alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        
        // Redirigir al login de admin
        window.location.href = '/admin/login';
      } else if (isClientRoute) {
        console.log('[Auth] Limpiando sesión de cliente');
        localStorage.removeItem('clientToken');
        
        // Mostrar mensaje antes de redirigir
        alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        
        // Redirigir al login de cliente
        window.location.href = '/login';
      } else {
        // Si no podemos determinar, limpiar todo y redirigir a home
        console.log('[Auth] Limpiando todas las sesiones');
        localStorage.removeItem('token');
        localStorage.removeItem('clientToken');
        alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        window.location.href = '/';
      }
    }
    
    // Rechazar la promesa para que el error pueda ser manejado por el código que hizo la petición
    return Promise.reject(error);
  }
);

export default axios;
